export const MAX_EMAIL_NOTIFICATIONS_COUNT = 4;
